export var delay = function (milliseconds) { return new Promise(function (res) { return setTimeout(res, milliseconds); }); };
//# sourceMappingURL=delay.js.map